import { UserAccountSummary } from '~domain/model/account/user-account-summary';
import { LanguageId } from '~domain/model/core/supported-languages';
import { enqueueClarityAction } from '~frontend-common/helper/core/clarity';
import { userAccountsClient } from '~web-portal/clients/user-accounts-client';
import { getUserAuth } from '~web-portal/helpers/get-user-auth';
import { useUserStore } from '~web-portal/stores';

export class UserService {
  /**
   * Get the user profile for current user
   */
  async loadUserProfile(): Promise<UserAccountSummary> {
    const { userId, accessToken } = getUserAuth();
    const user = await userAccountsClient.get(accessToken, userId);

    enqueueClarityAction((clarity) => clarity('identify', user.id, null, null, user.id));
    useUserStore.getState().setUser(user);

    return user;
  }

  /**
   * Update the email for current user. Requires a specific access token to modify sensitive user account info
   */
  async updateEmail(specialAccessToken: string, email: string): Promise<UserAccountSummary> {
    const { userId } = getUserAuth();
    const user = await userAccountsClient.update(specialAccessToken, userId, { userInfoSensitive: { email } });

    useUserStore.getState().setUser(user);
    return user;
  }

  /**
   * Update the phone number for current user
   */
  async updatePhoneNumber(phoneNumber: string): Promise<UserAccountSummary> {
    const { userId, accessToken } = getUserAuth();
    const user = await userAccountsClient.update(accessToken, userId, { userInfo: { phoneNumber } });

    useUserStore.getState().setUser(user);
    return user;
  }

  /**
   * Update the language for the current user
   */
  async updateLanguage(language: LanguageId): Promise<UserAccountSummary> {
    const { userId, accessToken } = getUserAuth();
    const user = await userAccountsClient.update(accessToken, userId, { userInfo: { language } });

    useUserStore.getState().setUser(user);
    return user;
  }
}

export const userService = new UserService();
